import { http } from '@lib/api';
import type {
  AnalyticsReportArchive,
  AnalyticsReportDetail,
  AnalyticsReportSummary,
} from './analyticsTypes';

export const ANALYTICS_QUERY_KEYS = {
  archive: ['analytics', 'reports'] as const,
  detail: (id: string) => ['analytics', 'reports', id] as const,
} as const;

export function listAnalyticsReports(): Promise<AnalyticsReportArchive> {
  return http.get<AnalyticsReportArchive>('/api/analytics/reports');
}

export function readAnalyticsReport(id: string): Promise<AnalyticsReportDetail> {
  return http.get<AnalyticsReportDetail>(`/api/analytics/reports/${encodeURIComponent(id)}`);
}

export function generateAdhocReport(
  periodStart: string,
  periodEnd: string,
): Promise<AnalyticsReportDetail> {
  return http.post<AnalyticsReportDetail>(
    `/api/analytics/reports/adhoc/${encodeURIComponent(periodStart)}/${encodeURIComponent(periodEnd)}`,
    undefined,
    { timeout: 600_000 },
  );
}

export function deleteAnalyticsReport(id: string): Promise<void> {
  return http.delete<void>(`/api/analytics/reports/${encodeURIComponent(id)}`);
}

/** The archive-list fields of a full report. */
export function summaryOf(report: AnalyticsReportDetail): AnalyticsReportSummary {
  return {
    id: report.id,
    period_kind: report.period_kind,
    period_start: report.period_start,
    period_end: report.period_end,
    generated_at: report.generated_at,
  };
}
